// AI Upgraded Component
import { Component, Input, OnInit } from '@angular/core';
import { ExportService } from '@client/ng2/core/services/export.service';
import { SessionService } from '@monsido/core/session/session.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import moment from 'moment';
import { DEFAULTS } from '@client/ng2/core/constants/defaults.constant';
import { DialogService } from '@monsido/angular-shared-components';
import { MON_EVENTS } from '@monsido/ng2/core/constants/mon-events.constant';
import { CsvExportsOverlayComponent } from '../overlay/csv-exports.component';

@Component({
    selector: 'csv-export-compound-dialog',
    templateUrl: './dialog-compound.component.html',
})
export class CsvExportCompoundDialogComponent implements OnInit {
    @Input() exports: any[] = [];
    @Input() monDialogId!: number;

    onDownload: boolean = false;
    downloadDone: boolean = false;
    date = {
        startDate: moment().subtract(3, 'months'),
        endDate: moment(),
    } as unknown as Record<string, moment.Moment>;
    dateFormat: string = DEFAULTS.DATE_FORMAT;
    datepickerOptions: any = { opens: 'center' };


    constructor (
        private readonly exportService: ExportService,
        private readonly sessionService: SessionService,
        private readonly monEventService: MonEventService,
        private readonly dialogService: DialogService,
    ) {}

    ngOnInit (): void {
        const queryParams = new URLSearchParams(window.location.search);
        const startDate = queryParams.get('from');
        const endDate = queryParams.get('to');

        if (startDate && endDate) {
            this.date.startDate = moment(startDate);
            this.date.endDate = moment(endDate);
        }
    }

    goToExports (): void {
        const dialogParams = {
            component: CsvExportsOverlayComponent,
            dialogOptions: {
                size: 'md',
            },
        };
        this.dialogService.closeAll();
        this.monEventService.run(MON_EVENTS.LOAD_NG2_DIALOG, dialogParams);
    }

    download (exportParams: any): void {
        const params = {
            recipients: [this.sessionService.me?.email ?? ''],
            ...exportParams,
            category_ref: `${this.date.startDate.format(DEFAULTS.API_REQUEST_DATE_FORMAT)},${this.date.endDate.format(DEFAULTS.API_REQUEST_DATE_FORMAT)}`,
        };

        this.onDownload = true;
        this.exportService.create(params).subscribe(
            () => {
                this.onDownload = false;
                this.downloadDone = true;
            },
            () => {
                this.onDownload = false;
            },
        );
    }
}
